import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Serviceheader from '../components/Service/Serviceheader'
import Services from '../components/Service/Services'
import SpecialOffer from '../components/Home/SpecialOffer'

const Servicepage = () => {
    return (
        <div>

            <Navbar />
            <Serviceheader />
            <Services />
            <SpecialOffer />
            <Footer />

        </div>
    )
}

export default Servicepage